import React from "react";

/**
 * CounterBox — issue #750 § 5.4. The blank numeric input used 35 times on
 * the scorecard (DirectionA2). A thin, controlled wrapper around a native
 * `<input>` — styling only; parsing an untouched box into `null` rather
 * than `0` is `counterOrNull` in `frontend/src/lib/counters.js`, and stays
 * with the caller.
 */
export const CounterBox = React.forwardRef(function CounterBox(
  { className = "", "data-testid": testId, style, ...rest },
  ref
) {
  return (
    <input
      ref={ref}
      data-testid={testId}
      type="text"
      inputMode="decimal"
      autoComplete="off"
      className={`nw-kit-input ${className}`}
      style={{
        width: "100%",
        height: "var(--nw-size-control)",
        borderRadius: "var(--nw-radius-control)",
        border: "1px solid var(--nw-line)",
        background: "var(--nw-surface)",
        textAlign: "center",
        fontFamily: "'Manrope', sans-serif",
        fontWeight: 800,
        fontSize: 20,
        color: "var(--nw-ink)",
        boxShadow: "none",
        outline: "none",
        ...style,
      }}
      {...rest}
    />
  );
});

export default CounterBox;
